import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {TrueGritStatics} from "../TrueGritStatics";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {TrueGrit} from "../TrueGrit";
import {gsap} from "gsap";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";

/**
 * Created by Jerker Nord on 2021-09-07.
 */

export class TrueGritInitialWinBelowView extends PIXI.Container implements StageLayer{

    private _winShines:TimelineSprite[][];

    private static WIN_SHINE_OFFSET:PIXI.Point = new PIXI.Point(71, 70);
    private static WIN_SHINE_TOP_REEL_OFFSET:PIXI.Point = new PIXI.Point(71, -56);

    constructor() {
        super();
        this.name = "TrueGritInitialWinBelowView";
        this.init();
    }

    private init() {
        this._winShines = [];
        let tempWinShineAnimation:TimelineSprite;
        let reelSymHeigt:number;
        for(let i:number = 0; i < 6; i++) {
            const subWinShines:TimelineSprite[] = [];
            reelSymHeigt = 4;
            if (i > 0 && i < 4){
                reelSymHeigt = 5;
            }
            for(let j:number = 0; j < reelSymHeigt; j++) {
                tempWinShineAnimation = new TimelineSprite(TrueGrit.assetLoader.getTextures("winAnimations/winShine/winshine_"));
                tempWinShineAnimation.anchor.set(0.5, 0.5);
                tempWinShineAnimation.position = TrueGritInitialWinBelowView.WIN_SHINE_OFFSET;
                if (i > 0 && i < 4){
                    tempWinShineAnimation.position = TrueGritInitialWinBelowView.WIN_SHINE_TOP_REEL_OFFSET;
                }
                tempWinShineAnimation.position.x += i * TrueGritStatics.symbolWidth;
                tempWinShineAnimation.position.y += j * TrueGritStatics.symbolHeight;
                tempWinShineAnimation.visible = false;
                this.addChild(tempWinShineAnimation);
                subWinShines.push(tempWinShineAnimation);
            }
            this._winShines.push(subWinShines);
        }
        this.onResize();
    }

    onResize():void {
        this.position = TrueGritStatics.MAIN_REELS_VIEW_POSITION;
        if(!NolimitApplication.isLandscape) {
            this.position.y = this.position.y - (TrueGritStatics.PORTRAIT_Y_OFFSET + NolimitApplication.screenBounds.top) / 2;
        }
    }

    public getWinShineAnimation(reel:number, row:number):gsap.core.Timeline {
        if (reel == 0 || reel > 3){
            row --;
        }
        return this._winShines[reel][row].getAnimationAutoShowHide();
    }
}